import { defineStyleConfig } from '@chakra-ui/react';
import { ChakraStylesConfig } from 'chakra-react-select';

export const SelectComponentName = 'ReactSelect';

const styles: ChakraStylesConfig = {
  dropdownIndicator: (provided) => ({
    ...provided,
    px: 2,
  }),
};

// pass the custom chakra-react-select styles via chakra theming so we don't have to use a separate context/mechanism to customize them
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SelectStyle = defineStyleConfig({ baseStyle: styles as any });
